export default "__VITE_ASSET__QksZ8XI3__"